import { Theme, ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({

});

export default theme;